import React from 'react';
import Text from '@amzn/meridian/text';
import { useTranslation } from 'src/arb-wrapper';

interface ShowingCountProps {
  page: number;
  pageSize: number;
  total: number;
  /** i18n key to use. Defaults to 'showing_count'. Must accept {start}, {end}, {total} params. */
  i18nKey?: string;
}

/**
 * Standardized "Showing X-Y of Z" display for paginated tables.
 * Renders nothing when total is 0.
 */
export const ShowingCount: React.FC<ShowingCountProps> = ({ page, pageSize, total, i18nKey = 'showing_count' }) => {
  const { t } = useTranslation();

  if (total === 0) return null;

  const start = Math.min((page - 1) * pageSize + 1, total);
  const end = Math.min(page * pageSize, total);

  return (
    <Text color="secondary" data-testid="showing-count" type="b200">
      {t(i18nKey, {
        start: String(start),
        end: String(end),
        total: String(total),
      })}
    </Text>
  );
};
